module.exports = __webpack_public_path__ + "static/media/matcapFV.431c67c3.jpg";